export const selectedConfiguration: any = {
  id: 'config-id',
  slug: null,
  name: 'test',
  version: '1.0.0',
  participants: [
    {
      email: 'user@nylas.com',
      is_organizer: true,
      name: '',
      availability: {
        calendar_ids: ['primary'],
        open_hours: [
          {
            days: [1, 2, 3, 4, 5],
            exdates: null,
            timezone: 'America/Toronto',
            start: '09:00',
            end: '17:00',
          },
        ],
      },
      booking: {
        calendar_id: 'user@nylas.com',
      },
      timezone: 'America/Toronto',
    },
  ],
  requires_session_auth: false,
  availability: {
    duration_minutes: 30,
    interval_minutes: 30,
    availability_rules: {
      availability_method: 'collective',
      buffer: {
        before: 0,
        after: 0,
      },
      default_open_hours: [
        {
          days: [1, 2, 3, 4, 5],
          exdates: null,
          timezone: 'America/Toronto',
          start: '09:00',
          end: '17:00',
        },
      ],
      round_robin_group_id: '',
    },
  },
  event_booking: {
    title: 'test',
    timezone: 'America/Toronto',
    description: '',
    location: '',
    booking_type: 'booking',
    conferencing: {},
    hide_participants: null,
    disable_emails: null,
  },
  scheduler: {
    available_days_in_future: 30,
    min_cancellation_notice: 60,
    min_booking_notice: 60,
    hide_rescheduling_options: false,
    hide_cancellation_options: false,
    hide_additional_guests: false,
    cancellation_policy: '',
    email_template: {
      booking_confirmed: {},
    },
  },
  appearance: null,
};

export function formatTime(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  const formattedMinutes = minutes < 10 ? '0' + minutes.toString() : minutes.toString();

  const formattedTime = `${hours.toString().padStart(2, '0')}:${formattedMinutes.toString().padStart(2, '0')} ${ampm}`;
  return formattedTime;
}
